import { Routes } from '@angular/router';
import { LayoutComponent } from './pages/layout/layout.component';
import { AppRoutes } from '@core/enums';

export const routes: Routes = [
  {
    path: '',
    redirectTo: AppRoutes.APPLICATIONS,
    pathMatch: 'full',
  },
  {
    path: AppRoutes.APPLICATIONS,
    component: LayoutComponent,
    loadChildren: () => import('@features/application/application.routes').then(m => m.APPLICATION_ROUTES),
  },
  {
    path: AppRoutes.RENEWAL,
    component: LayoutComponent,
    loadChildren: () => import('@features/token-renewal/token-renewal.routes').then(m => m.TOKEN_RENEWAL_ROUTES),
  },
  {
    path: AppRoutes.OTHER,
    redirectTo: AppRoutes.APPLICATIONS,
  },
];
